import { useNavigate, useParams } from 'react-router';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { PageHeader } from '../components/PageHeader';
import { EmptyState } from '../components/States';
import { CompaniesTab } from '../features/admin/CompaniesTab';
import { AgentsTab } from '../features/admin/AgentsTab';
import { ModelsTab } from '../features/admin/ModelsTab';
import { ReviewProfilesTab } from '../features/admin/ReviewProfilesTab';
import { ExclusionTab } from '../features/admin/ExclusionTab';
import { OperationsTab } from '../features/admin/OperationsTab';
import { UsersTab } from '../features/admin/UsersTab';

const TABS = [
  { key: 'gesellschaften', label: 'Gesellschaften', el: <CompaniesTab /> },
  { key: 'bearbeiter', label: 'Bearbeiter', el: <AgentsTab /> },
  { key: 'modelle', label: 'Modelle/Zugangsdaten', el: <ModelsTab /> },
  { key: 'pruefprofile', label: 'Prüfprofile', el: <ReviewProfilesTab /> },
  { key: 'negativliste', label: 'Negativliste', el: <ExclusionTab /> },
  { key: 'betrieb', label: 'Betrieb', el: <OperationsTab /> },
  { key: 'nutzer', label: 'Nutzer/Scopes', el: <UsersTab /> },
] as const;

export function AdminPage() {
  const { tab = 'gesellschaften' } = useParams();
  const nav = useNavigate();
  const current = TABS.find((t) => t.key === tab);
  return (
    <>
      <PageHeader eyebrow="Administration" title="Administration" description="Gesellschaftsregeln, Bearbeiter, Modelle, Prüfprofile, Negativliste und Betrieb dieser Installation." />
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={current ? tab : false} onChange={(_, v) => nav(`/admin/${v}`)} variant="scrollable" scrollButtons="auto" aria-label="Administrationsbereiche">
          {TABS.map((t) => (
            <Tab key={t.key} value={t.key} label={t.label} id={`admin-tab-${t.key}`} aria-controls={`admin-panel-${t.key}`} />
          ))}
        </Tabs>
      </Box>
      <Box role="tabpanel" id={`admin-panel-${tab}`} aria-labelledby={`admin-tab-${tab}`}>
        {current ? current.el : <EmptyState title="Bereich nicht gefunden" />}
      </Box>
    </>
  );
}
